// Helpers puros del aviso de transferencia pendiente del Lead Agent (RET-1764).
//
// La resolución de superficie y tamaño se REUSA de los banners hermanos para que todos
// los avisos del Lead Agent vivan en las mismas rutas y con las mismas reglas de
// tamaño; aquí solo se agrega el formato del monto, que ningún hermano necesitaba.

import {
  resolveBannerSize,
  resolveSurface,
} from 'src/components/LeadAgentAcceptanceBanner/LeadAgentAcceptanceBanner.functions';

export { resolveBannerSize, resolveSurface };
export type { tLeadAgentBannerSize } from 'src/components/LeadAgentAcceptanceBanner/LeadAgentAcceptanceBanner.functions';

/**
 * Convierte los centavos de la factura a un monto legible en su propia moneda.
 *
 * La moneda viene del backend (la de la suscripción del cliente) y NO se asume MXN: el
 * mismo cobro existe en dólares, y mostrar "$3,814.78" cuando son dólares —o al revés—
 * cambia lo que el cliente cree que debe transferir.
 *
 * El FORMATO sigue al idioma del usuario, no a uno fijo: un cliente de Brasil leía la copia
 * en portugués y el monto con formato mexicano. La moneda (qué se debe) y el formato (cómo
 * se escribe) son cosas distintas — la primera viene del backend, la segunda del idioma.
 *
 * Una moneda inválida degrada al monto sin símbolo en vez de romper el aviso.
 */
export function formatInvoiceAmount(
  amountCents: number,
  currency: string,
  locale?: string,
): string {
  const value = Number.isFinite(amountCents) ? amountCents / 100 : 0;
  const idioma = locale && locale !== '' ? locale : 'es-MX';

  try {
    return new Intl.NumberFormat(idioma, {
      style: 'currency',
      currency: currency.toUpperCase(),
    }).format(value);
  } catch {
    try {
      return new Intl.NumberFormat(idioma, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch {
      // Idioma inválido además de moneda inválida: se cae al default y se muestra igual.
      return new Intl.NumberFormat('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    }
  }
}
